import clsx from 'clsx';
import React from 'react';

import CarrierLogo from "../CarrierLogo";
import MarketingTagsList from "../MarketingTagsList";
import { createStyles } from "./styles";









var SponsorHeader = function SponsorHeader(_ref)





{var carrier = _ref.carrier,marketingTagIds = _ref.marketingTagIds,portfolioId = _ref.portfolioId,marketingTags = _ref.marketingTags,_ref$styles = _ref.styles,styles = _ref$styles === void 0 ? '' : _ref$styles;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.portfolioHeader, styles) }, /*#__PURE__*/
    React.createElement(CarrierLogo, { carrier: carrier }), /*#__PURE__*/
    React.createElement(MarketingTagsList, {
      marketingTagIds: marketingTagIds,
      marketingTags: marketingTags,
      portfolioId: portfolioId })));



};

export default SponsorHeader;
//# sourceMappingURL=index.js.map